import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as ExperiencesActions from "../../actions/experiencesActions";

const deleteExperienceSuccess = createLogic({
	type: ActionTypes.DELETE_EXPERIENCE_SUCCESS,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(ExperiencesActions.loadExperiences());
		done();
	},
});

export default [deleteExperienceSuccess];
